/**
 * Personal Gmail domains Yaruta supports for the Gmail-connecting account.
 * Workspace / business (custom-domain) accounts are unsupported in MVP.
 *
 * NOTE: keep this list byte-identical to the edge copy
 * (apps/supabase/supabase/functions/_shared/gmail-account-support.ts) — it
 * feeds the authoritative Gate 3 server check; if they drift, login (Gate 1)
 * and Gmail-connect (Gate 3) disagree.
 *
 * TODO(@dsalomon): QA test domain — remove 'griseldalabs.com' before GA / once
 * QA wraps. It's an internal Workspace domain allowlisted ONLY so the team can
 * test end-to-end on a real (non-personal) Google account; it grants PRIMARY
 * signup + Gmail writes to ANY @griseldalabs.com mailbox.
 */
export const SUPPORTED_GMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'griseldalabs.com',
] as const;

/**
 * True only for a personal Gmail address (@gmail.com / @googlemail.com).
 * Case-insensitive; takes the substring after the LAST '@' and requires an
 * exact allowlist match, so spoofs like `x@gmail.com.evil.com` fail.
 */
export function isSupportedGmailAddress(
  email: string | null | undefined,
): boolean {
  if (!email) return false;
  const at = email.lastIndexOf('@');
  if (at < 1 || at === email.length - 1) return false;
  const domain = email.slice(at + 1).toLowerCase();
  return (SUPPORTED_GMAIL_DOMAINS as readonly string[]).includes(domain);
}
